import React from 'react';
import noveltyPic from '/assets/images/2022aug/novelty_sold.png';

import '../styles/Novelty.scss' 

const Novelty = () => {
    return (
        <section className="novelty" id="novelty">
            <div className="novelty__inner">
                <div className="novelty__text">
                    <h2 className="novelty__mainTtl">SPECIAL NOVELTY</h2>
                    <h3 className="novelty__subTtl">先着数量限定ノベルティ</h3>
                    <p className="novelty__expla">『BELLINI SET BOX』『COCO SET BOX』を2箱以上同時に<br className="sp-invisible"></br>ご購入頂いたお客様に先着数量限定にてノベルティの<br></br>『U/CHOOオリジナルポーチ』をプレゼント</p>
                    <p className="novelty__expla novelty__expla__sold">ノベルティのオリジナルポーチはご好評につき終了致しました。<br />沢山のご注文ありがとうございます!</p>
                    <p className="novelty__attention">
                    ※『SPECIAL SET BOX』はノベルティ対象外となります。<br></br>
                    ※無くなり次第終了となります
                    </p>
                </div>
                <div className="novelty__image">
                    <div><img src={noveltyPic} alt="ノベルティ" width="744" height="800" /></div>
                </div>
            </div>
        </section>
    )
}

export default Novelty